<template>
    <b-container fluid>
        <b-row>
            <b-col lg="12" sm="12">
                <iq-card>
                    <template v-slot:body>
                        <b-row>
                            <b-col xl="12" lg="12" sm="12">
                                <b-overlay :show="loading" rounded="sm">
                                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                        <b-form @submit.prevent="handleSubmit(register)" @reset.prevent="reset">
                                            <!--    training title -->
                                            <b-row>
                                                <b-col lg="6" sm="6">
                                                    <ValidationProvider name="Organization" vid="org_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="org_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('globalTrans.organization') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                :disabled="formData.modules[0].module_name_id ? true : false"
                                                                v-model="formData.org_id"
                                                                :options="orgList"
                                                                id="org_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="fiscal_year_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('globalTrans.fiscal_year') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                :disabled="formData.modules[0].module_name_id ? true : false"
                                                                v-model="formData.fiscal_year_id"
                                                                :options="fiscalYearList"
                                                                id="fiscal_year_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <ValidationProvider name="Training Title" vid="training_name_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="training_name_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('elearning_config.training')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                :disabled="formData.modules[0].module_name_id ? true : false"
                                                                v-model="formData.training_name_id"
                                                                :options="trainingNameList"
                                                                id="training_name_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>
                                            <hr>
                                            <!-- Module Loop Start Here -->
                                            <div v-for="(module, index) in formData.modules" :key="index">
                                                <iq-card class="p-2">
                                                    <b-row>
                                                        <b-col lg="6" sm="6">
                                                            <b-spinner v-if="moduleSpinLoader" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                                            <ValidationProvider name="Module Name" rules="required|min_value:1">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="5"
                                                                    label-for="module_name_id"
                                                                    slot-scope="{ valid, errors }"
                                                                >
                                                                    <template v-slot:label>
                                                                        {{$t('tp_management.course_module')}} <span class="text-danger">*</span>
                                                                    </template>
                                                                    <b-form-select
                                                                        plain
                                                                        v-model="module.module_name_id"
                                                                        :options="moduleNameList"
                                                                        id="module_name_id"
                                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                                    >
                                                                        <template v-slot:first>
                                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                        </template>
                                                                    </b-form-select>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                    </b-row>
                                                    <!-- Transport Driver Nested Loop Start Here -->
                                                    <b-table-simple  bordered>
                                                        <thead>
                                                        <tr class="bg-primary">
                                                            <th style="width:10%" scope="col">{{ $t('globalTrans.sl_no') }}</th>
                                                            <th scope="col">{{ $t('tp_management.detail_syllabus') + ' ' +  $t('elearning_config.en') }}</th>
                                                            <th scope="col">{{ $t('tp_management.detail_syllabus') + ' ' +  $t('elearning_config.bn') }}</th>
                                                            <th scope="col" class="text-center">{{ $t('globalTrans.action') }}</th>
                                                        </tr>
                                                        </thead>
                                                        <b-tbody>
                                                            <b-tr v-for="(syllabus, inx) in module.syllabuses" :key="inx">
                                                                <b-td>
                                                                    {{ $n(inx + 1) }}
                                                                </b-td>
                                                                <b-td>
                                                                    <ValidationProvider name="Detailed Syllabus (En)" vid="name_id" rules="required|max:199">
                                                                        <b-form-group
                                                                            class="mb-0"
                                                                            slot-scope="{ valid, errors }"
                                                                        >
                                                                            <b-form-input
                                                                                v-model="syllabus.name"
                                                                                id="name_id"
                                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                            >
                                                                            </b-form-input>
                                                                            <div class="invalid-feedback">
                                                                                {{ errors[0] }}
                                                                            </div>
                                                                        </b-form-group>
                                                                    </ValidationProvider>
                                                                </b-td>
                                                                <b-td>
                                                                    <ValidationProvider name="Detailed Syllabus (Bn)" vid="name_bn_id" rules="required|max:199">
                                                                        <b-form-group
                                                                            class="mb-0"
                                                                            slot-scope="{ valid, errors }"
                                                                        >
                                                                            <b-form-input
                                                                                v-model="syllabus.name_bn"
                                                                                id="name_bn_id"
                                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                            >
                                                                            </b-form-input>
                                                                            <div class="invalid-feedback">
                                                                                {{ errors[0] }}
                                                                            </div>
                                                                        </b-form-group>
                                                                    </ValidationProvider>
                                                                </b-td>
                                                                <b-td>
                                                                    <button v-if="inx === formData.modules[index].syllabuses.length - 1" type="button" class="btn btn-sm btn-primary" @click.prevent="addSyllabus(index)">
                                                                        +
                                                                    </button>
                                                                    <b-button v-if="inx > 0" type="button" @click="removeSyllabus(inx, index)" class="btn btn- iq-bg-danger btn-sm text-center ml-1"><i class="ri-delete-bin-line m-0"></i></b-button>
                                                                </b-td>
                                                            </b-tr>
                                                        </b-tbody>
                                                    </b-table-simple>
                                                    <!-- Transport Driver Nested Loop End Here -->
                                                </iq-card>
                                                <b-row>
                                                    <b-col lg="12" sm="12" class="text-right mb-3">
                                                        <button v-if="index === formData.modules.length - 1" type="button" class="btn btn-sm iq-bg-primary" @click.prevent="addModule(index)">
                                                            {{ $t('ds_institute_management.add')}}
                                                        </button>
                                                        <button v-if="index > 0" type="button" class="btn btn-sm iq-bg-danger" @click="removeModule(index)"
                                                        >
                                                            {{ $t('ds_institute_management.delete')}}
                                                        </button>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-3"></div>
                                                <div class="col text-right">
                                                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                                    &nbsp;
                                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                                </div>
                                            </div>
                                        </b-form>
                                    </ValidationObserver>
                                </b-overlay>
                            </b-col>
                        </b-row>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
import { courseModuleStoreApi, courseModuleUpdateApi } from '../../api/routes'
import { moduleNameListApi } from '../../../configuration/api/routes'

export default {
    name: 'FormLayout',
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        // this.getModuleList()
        if (this.id) {
            this.moduleSpinLoader = true
            const tmp = this.getData()
            this.formData = tmp
        }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            loading: false,
            moduleSpinLoader: false,
            formData: {
                org_id: 0,
                fiscal_year_id: 0,
                training_name_id: 0,
                modules: [
                    {
                        module_name_id: 0,
                        syllabuses: [
                            {
                                name: '',
                                name_bn: ''
                            }
                        ]
                    }
                ]
            },
            detailsData: {
                name: '',
                name_bn: ''
            },
            moduleNameList: [],
            allModuleList: []
        }
    },
    computed: {
        trainingNameList: function () {
            const obj = this.$store.state.TrainingElearning.commonObj.trainingNameList.filter(item => item.status === 1)
            return obj.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        orgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0).map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item.value, text: item.text_bn }
                } else {
                    return { value: item.value, text: item.text_en }
                }
            })
        },
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0).map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item.value, text: item.text_bn }
                } else {
                    return { value: item.value, text: item.text_en }
                }
            })
        }
    },
    watch: {
        'formData.training_name_id': function () {
            this.formData.modules.module_name_id = 0
            this.getModuleNameList()
        }
    },
    methods: {
        addModule (index) {
            this.$refs.form.validate()
            this.formData.modules.push({
                module_name_id: 0,
                syllabuses: [
                    {
                        name: '',
                        name_bn: ''
                    }
                ]
            })
            this.moduleNameList.forEach((element, key) => {
                if (element.value === this.formData.modules[index].module_name_id) {
                    element.disabled = true
                }
            })
        },
        addSyllabus (index) {
            this.formData.modules.forEach((element, key) => {
                if (key === index) {
                    element.syllabuses.push({
                        name: '',
                        name_bn: ''
                    })
                }
            })
        },
        removeSyllabus (inx, index) {
            this.formData.modules.forEach((element, key) => {
                if (key === index) {
                    element.syllabuses.splice(inx, 1)
                }
            })
        },
        removeModule (index) {
            this.formData.modules.splice(index, 1)
        },
        async register () {
            this.loading = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }
            if (this.id) {
                result = await RestApi.putData(trainingElearningServiceBaseUrl, `${courseModuleUpdateApi}/${this.id}`, this.formData)
            } else {
                result = await RestApi.postData(trainingElearningServiceBaseUrl, courseModuleStoreApi, this.formData)
            }
            this.$store.dispatch('mutateCommonProperties', loadinState)
            if (result.success) {
                this.loading = false
                this.$store.dispatch('TrainingElearning/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
                this.$bvModal.hide('modal-4')
            } else {
                this.loading = false
                this.$refs.form1.setErrors(result.errors)
            }
        },
        getData () {
            const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
            return JSON.parse(JSON.stringify(tmpData))
        },
        async getModuleNameList () {
            this.moduleSpinLoader = true
            const result = await RestApi.getData(trainingElearningServiceBaseUrl, moduleNameListApi, { plan_module: true, training_name_id: this.formData.training_name_id })
            if (result.success) {
                this.moduleSpinLoader = false
                this.moduleNameList = result.data.map(item => {
                    return Object.assign({ value: item.id, text: this.$i18n.locale === 'en' ? item.name : item.name_bn, training_name_id: item.training_name_id })
                })
            }
        }
    }
}
</script>
<style scoped>
.overlay {
    position: absolute;
    left: 65%;
    z-index: 9999;
    top: 10px;
    text-align: center;
}
</style>
